import React from 'react'
import { GetServerSidePropsContext } from 'next'
import Link from 'next/link'
import styled from 'styled-components/macro'
import { connect } from 'react-redux'

import { ColorsMap } from '@/utils/Theme'

import { initializeStore } from '@/redux/store'
import { getSettings } from '@/redux/actions'

import { Text } from '@/components/Text'
import { PageLayout } from '@/components/Layout/PageLayout'
import { Button } from '@/components/Button'
import { Path } from '@/components/Path'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 14%;
  padding-bottom: 4rem;
`

const BrandCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, calc((100% - 2rem) / 3));
  row-gap: 1rem;
  justify-content: space-between;
`

const BrandCardImg = styled.img`
  background: ${ColorsMap.white};
  width: 40%;
  opacity: 0.5;
  transition: opacity 0.3s;
`

const BrandCard = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${ColorsMap.white};
  height: 10rem;
  &:hover {
    box-shadow: -20px 20px 20px 0 rgba(0, 0, 0, 0.006);

    ${BrandCardImg} {
      opacity: 1;
    }
  }
`

const GolfPage = ({ state }) => (
  <PageLayout title={`Golf | ${state.settings.name}`} secondary>
    <Path pathLinks={[<span>Golf</span>]} />
    <Wrapper>
      <Text fontSize="xl" textColor={ColorsMap.primary} fontWeight="bold" m="2.5rem auto">
        Golf
      </Text>
      <BrandCardsWrapper>
        <Link href="/brand/cobra-puma-golf/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/cobra-puma-golf.svg" alt="Cobra Puma logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/clicgear/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/clicgear.svg" alt="Clicgear logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/pure-2-improve-golf/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/pure-2-improve.svg" alt="Pure2Improve logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/lignum-tee/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/lignum-tee.svg" alt="Lignum Tee logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/spalding/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/spalding.svg" alt="Spalding logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/sniper-golf/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/sniper-golf.svg" alt="Snipergolf logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/trilite/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/trilite.svg" alt="Trilite logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/rovic/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/rovic.svg" alt="Rovic logo" />
          </BrandCard>
        </Link>
        <Link href="/brand/volvik/" passHref>
          <BrandCard>
            <BrandCardImg src="/images/logos/volvik.svg" alt="Volvik logo" />
          </BrandCard>
        </Link>
      </BrandCardsWrapper>
    </Wrapper>
  </PageLayout>
)

const mapStateToProps = (state: { state: object }) => ({
  state,
})

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default connect(mapStateToProps)(GolfPage)

